import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch, apiRemove } from '../modules/utility';

const apiBase = 'equipment';
//const item = 'equipment';
const idsField = 'equipmentIds';

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: idsField,
			params,
			dispatch,
			callback,
		});
	};
};

const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

const remove = ({ equipmentId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			dispatch,
			id: equipmentId,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	//- Get a single equipment and the list of equipments
	const equipmentId = ownProps.equipmentId
		? ownProps.equipmentId
		: _.get(ownProps, ['match', 'params', 'equipmentId']);
	const equipment = _.get(state.maps, ['equipment', equipmentId]);

	let equipments = [];
	if (state.lists.equipmentIds) {
		equipments = _.map(state.lists.equipmentIds, (id) => state.maps.equipment[id]);
	}

	return {
		equipment,
		equipments,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getEquipment: get,
			addEquipment: add,
			updateEquipment: update,
			searchEquipments: search,
			removeEquipment: remove,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
